import { useState } from 'react'
import { Icon } from '@artprov/design-system'
import UserProfileModal from './UserProfileModal'

function UserMenuButton() {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false)

  const handleClick = () => {
    setIsDropdownOpen(!isDropdownOpen)
  }

  return (
    <div className="relative">
      <button
        onClick={handleClick}
        className="flex items-center gap-1 hover:opacity-80 transition-opacity px-2 py-1"
        aria-label="Abrir menú de perfil"
      >
        <span className="text-sm font-semibold leading-none tracking-[0.1px] text-primary-10">Mi perfil</span>

        <Icon icon="expand_more" size="small" className="text-[#1565C0]" />
      </button>

      <UserProfileModal open={isDropdownOpen} setOpen={setIsDropdownOpen} />
    </div>
  )
}

export default UserMenuButton
